export const GENERATE_SUMMARY_LOADING_STATES = {
    DOWNLOAD_READY_FOR_ALL_PDFS_LOADING: "DOWNLOAD_READY_FOR_ALL_PDFS_LOADING",
    DOWNLOAD_READY_FOR_ALL_PDFS_READY: "DOWNLOAD_READY_FOR_ALL_PDFS_READY",
    DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_LOADING: "DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_LOADING",
    DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_READY: "DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_READY",
    DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_LOADING: "DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_LOADING",
    DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_READY: "DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_READY",
}

export const GENERATE_SUMMARY_LOADING_STATES_MESSAGE_MAP = {
    [GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_FOR_ALL_PDFS_LOADING]: " ",
    [GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_ALL_PDFS_FOR_PAYERS_LOADING]: " ",
    [GENERATE_SUMMARY_LOADING_STATES.DOWNLOAD_READY_PDFS_FOR_ALL_PAYERS_LOADING]: " ",

}